import axios from "axios"
import { setupInterceptors } from "./axios.interceptors"

export const api = setupInterceptors(
  axios.create({
    baseURL: import.meta.env.VITE_BASE_API_URL,
    paramsSerializer: (paramObj) => {
      const params = new URLSearchParams()

      Object.entries(paramObj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => params.append(key, v))
        } else {
          params.append(key, value)
        }
      })

      return params.toString()
    },
  })
)

export const workspaceApi = setupInterceptors(
  axios.create({
    baseURL: import.meta.env.VITE_WORKSPACE_API_URL,
  })
)

export const apiWithoutAuth = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
})
